module.exports = __webpack_public_path__ + "assets/pdf/鸿雁数据指南-简易版.ff4ff514.pdf";